import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// 扩展 dayjs 插件
dayjs.extend(relativeTime);

/**
 * 格式化时间戳为“刚刚”、“多少分钟之前”或“多少小时之前”
 * @param {number} timestamp - 时间戳
 * @returns {string} - 格式化后的时间字符串
 */
export function formatTimeAgo(timestamp) {
  const now = dayjs(); // 当前时间
  const targetTime = dayjs(timestamp); // 目标时间
  const diffInSeconds = now.diff(targetTime, 'second'); // 计算秒差
  const diffInMinutes = now.diff(targetTime, 'minute'); // 计算分钟差
  const diffInHours = now.diff(targetTime, 'hour'); // 计算小时差

  if (diffInSeconds < 60) {
    // 如果时间差小于 60 秒，显示“刚刚”
    return '刚刚';
  } else if (diffInMinutes < 60) {
    // 如果时间差小于 60 分钟，显示“多少分钟之前”
    return `${diffInMinutes}分钟之前`;
  } else {
    // 如果时间差大于等于 60 分钟，显示“多少小时之前”
    return `${diffInHours}小时之前`;
  }
}
export function isTowAgoDay(date) {
  const today = dayjs().subtract(2, "day").startOf("day"); // 两天前的开始时间
  const otherDay = dayjs(date).startOf("day"); // 需要判断的时间的开始时间
  return today.isSame(otherDay); // 比较是否相同
}

export function isThisYear(timestamp) {
  const now = dayjs();
  const startOfYear = now.startOf('year');
  const endOfYear = now.endOf('year');

  return timestamp >= startOfYear.valueOf() && timestamp <= endOfYear.valueOf();
}